import { Drawing } from "./index";
import { clear, flip } from "./paint";
import { rect } from "./select";
import { Coordinates, toCoords, toIdx } from "./cartesian";

export function translateX(drawing: Drawing, direction: 1 | -1): Drawing {
  const newDrawing = transform(drawing, ({ x, y }) => {
    x += direction;
    if (x === 0) x += direction;
    return {
      x,
      y,
    };
  });
  let columnToClear =
    direction === 1
      ? rect(0, Drawing.side * (Drawing.side - 1))
      : rect(Drawing.side - 1, Drawing.side * Drawing.side - 1);
  return clear(newDrawing, columnToClear, false);
}

export function translateY(drawing: Drawing, direction: 1 | -1): Drawing {
  const newDrawing = transform(drawing, ({ x, y }) => {
    y += direction;
    if (y === 0) y += direction;
    return {
      x,
      y,
    };
  });
  let rowToClear =
    direction === 1
      ? rect(Drawing.side * (Drawing.side - 1), Drawing.side * Drawing.side - 1)
      : rect(0, Drawing.side - 1);
  return clear(newDrawing, rowToClear, false);
}

export function reflectOverX(drawing: Drawing): Drawing {
  return transform(drawing, ({ x, y }) => {
    return {
      x,
      y: -y,
    };
  });
}

export function reflectOverY(drawing: Drawing): Drawing {
  return transform(drawing, ({ x, y }) => {
    return {
      x: -x,
      y,
    };
  });
}

export function rotatePos(drawing: Drawing): Drawing {
  return transform(drawing, ({ x, y }) => {
    return {
      x: y,
      y: -x,
    };
  });
}

export function rotateNeg(drawing: Drawing): Drawing {
  return transform(drawing, ({ x, y }) => {
    return {
      x: -y,
      y: x,
    };
  });
}

function transform(
  drawing: Drawing,
  transformFunction: (xy: Coordinates) => Coordinates
): Drawing {
  const idxs = [];
  for (let row = 0; row < Drawing.side; row++) {
    for (let col = 0; col < Drawing.side; col++) {
      const oldCoords = toCoords(row, col);
      const newCoords = transformFunction(oldCoords);
      const oldIdx = row * Drawing.side + col;
      const newIdx = toIdx(newCoords);
      if (
        newIdx === null ||
        !drawing.pixels[newIdx] === !drawing.pixels[oldIdx]
      ) {
        continue;
      }
      idxs.push(newIdx);
    }
  }
  return flip(drawing, idxs);
}
